import {
  Button,
  FormInput,
  FormNumber,
  FormRoot,
  FormTextarea,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";
import type {
  CreateQCWorkTypeDTO,
  UpdateQCWorkTypeDTO,
} from "../../domain/contracts/work-type";

const QCWorkTypeFormSchema = z.object({
  name: z.string().min(1, "ກະລຸນາປ້ອນຊື່ປະເພດງານ"),
  description: z.string().optional().nullable(),
  orderIndex: z.number().int().default(0),
});

export type QCWorkTypeFormValues = z.infer<typeof QCWorkTypeFormSchema>;

export function QCWorkTypeForm({
  initialValues,
  onSubmit,
  submitting,
}: {
  initialValues?: Partial<QCWorkTypeFormValues>;
  onSubmit: (values: CreateQCWorkTypeDTO | UpdateQCWorkTypeDTO) => void;
  submitting?: boolean;
}) {
  const methods = RHF.useForm<QCWorkTypeFormValues>({
    // biome-ignore lint/suspicious/noExplicitAny: zodResolver type inference issue
    resolver: zodResolver(QCWorkTypeFormSchema) as any,
    defaultValues: {
      name: "",
      description: null,
      orderIndex: 0,
      ...initialValues,
    },
  });

  return (
    <FormRoot<QCWorkTypeFormValues>
      methods={methods}
      onSubmit={(vals) =>
        onSubmit({
          name: vals.name,
          description: vals.description ?? null,
          orderIndex: vals.orderIndex ?? 0,
        })
      }
      className="space-y-4"
    >
      <FormInput
        name="name"
        label="ຊື່ປະເພດງານ"
        requiredMark
        placeholder="ຕົວຢ່າງ: ຜະລິດ, ແພັກ, ຈັດສົ່ງ"
      />
      <FormTextarea
        name="description"
        label="ຄໍາອະທິບາຍ"
        placeholder="ຄໍາອະທິບາຍ (ບໍ່ບັງຄັບ)"
        rows={3}
      />
      <FormNumber
        name="orderIndex"
        label="ລໍາດັບ"
        placeholder="0"
        hint="ລໍາດັບສໍາລັບການຈັດລຽງ (ຕໍ່າກ = ສະແດງກ່ອນ)"
      />
      <div className="flex justify-end gap-2">
        <Button
          type="button"
          onClick={methods.handleSubmit(onSubmit)}
          disabled={submitting}
          isLoading={submitting}
        >
          ບັນທຶກ
        </Button>
      </div>
    </FormRoot>
  );
}
